// extracted by mini-css-extract-plugin
export default {"label":"g5lHAPbth8UqciSfIjnQ","hint":"vmPFxQbU8AGiq9u9f0AQ","description":"C72r0PCW4NfhFOrHkJHK","subLabel":"qR15dWhS5rOwhkLLKF06","pulse":"SOzZ_s09WadIk5QLr57b"};